import { translations as PageHeaderTranslations } from 'components/page/i18n/locales/de/translations';
import { translations as CampaignTranslations } from 'containers/Campaign/i18n/locales/de/translations';
import { translations } from 'containers/Customer/i18n/locales/de/translations';
import { translations as RewardDeTranslation } from 'containers/Reward/i18n/locales/de/translations';
import { translations as RuleTranslations } from 'containers/Rule/i18n/locales/de/translations';
import { translations as GlobalTranslations } from 'utils/globalTranslation/locales/de/translations';
import {
  CampaignModule,
  CustomerModule,
  PageHeaderModule,
  RewardModule,
  RuleModule,
  GlobalModule
} from 'utils/i18n/TModules';

export const globalTranslations = {
  [CustomerModule]: translations,
  [RewardModule]: RewardDeTranslation,
  [CampaignModule]: CampaignTranslations,
  [PageHeaderModule]: PageHeaderTranslations,
  [RuleModule]: RuleTranslations,
  [GlobalModule]: GlobalTranslations
};
